<template>
  <div class="PublishData">
    <div class="row justify-content-start align-items-start px-4" style="text-align:start">
      <div class="col-md-12">
        <br/>
        To support collective learning and collaboration, we are building a public database of SDG Wheel and Crosswalk Analyses. By contributing your completed analysis, you can help others explore practical applications of the SDGs across different sectors and contexts. Your submission may be featured in training or course materials, research, or webinars.. You can choose whether or not to include your name and country.<br/> <strong>Note:</strong> If you choose not to share your analysis, you can still access and use the tool for your own learning and reflection.
        <br/>
        <br/>
        I consent to share my completed SDG Wheel or Crosswalk Analysis in a public database to support peer learning and collective insights.<br/>

        <MDBRadio
            label="Yes"
            name="consent-share"
            v-model="consentShareData"
            value="true"
        />
        <MDBRadio
            label="No"
            name="consent-share"
            v-model="consentShareData"
            value="false"
        />
        <br/>
        If yes, please indicate your preference:
        <MDBRadio
            label="I consent to have my name and country included in the shared database."
            name="consent-name"
            v-model="consentIncludeName"
            value="true"
        />
        <MDBRadio
            label="I consent to share my analysis anonymously (without name and country)."
            name="consent-name"
            v-model="consentIncludeName"
            value="false"
        />
      </div>
    </div>
  </div>
</template>

<script src="./_PublishData.js" lang="js"></script>
<style src="./_PublishData.less" lang="less" scoped></style>